// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f54d3ff973e359a5c01910881d30e92da7991fbc/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};